/**
 * Sentry verification page — mirrors `apps/api`'s `/debug-sentry` endpoint
 * (see `apps/api/src/index.ts:142`). Only throws when `VITE_SENTRY_DSN`
 * is set; otherwise the button is disabled and a hint is rendered so
 * local dev without secrets doesn't generate noise.
 */
import { isSentryEnabled } from '../sentry.js';

export function DebugSentryPage() {
  const enabled = isSentryEnabled();
  return (
    <div style={{ padding: 24 }}>
      <h2>Debug Sentry</h2>
      <p>
        Sentry status:{' '}
        <strong data-testid="sentry-status">{enabled ? 'enabled' : 'disabled'}</strong>.
      </p>
      {!enabled && (
        <p>
          Set <code>VITE_SENTRY_DSN</code> in <code>apps/portal/.env</code> to enable.
        </p>
      )}
      <button
        type="button"
        disabled={!enabled}
        onClick={() => {
          throw new Error('My first Sentry error from feluda-portal!');
        }}
      >
        Break the world
      </button>
    </div>
  );
}